const user = {
  namespaced: true,
  state: () => ({
    userInfo:{},//用户信息
    unitInfo:{},//单位信息
	memberInfo: {},
    pageTitle: ''
  }),
  mutations: {
    setUserInfo(state,data){//设置用户信息
      state.userInfo=data
    },
    setUnitInfo(state,data) {//设置单位信息
      state.unitInfo=data
    },
	setMemberInfo(state,data) {
		state.memberInfo=data
	},
	setPagetitle(state,data) {
		state.pageTitle=data
	}
  },
  // actions: {
  //   login({ commit }, userInfo) {//用户登录

  //   },
  // },
  getters: {
  }
}
export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js